import { render, staticRenderFns } from "./LoggedAccountConfirmation.vue?vue&type=template&id=746bf2a0&scoped=true&"
import script from "./LoggedAccountConfirmation.vue?vue&type=script&lang=ts&"
export * from "./LoggedAccountConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./LoggedAccountConfirmation.vue?vue&type=style&index=0&id=746bf2a0&lang=scss&scoped=true&"
import style1 from "./LoggedAccountConfirmation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746bf2a0",
  null
  
)

export default component.exports